<template>
  <div class="container checkoutPage">
    <div v-if="!pathMixin_isMeeting" class="has-text-centered gant-text mb-5">
      <h1 class="title gant-text">Almost there!</h1>
      <h2 class="subtitle gant-text">
        Review your itinerary and submit your booking.
      </h2>
    </div>

    <div class="columns">
      <div class="column" v-if="!isDesktop">
        <div class="boxWithBorder mb-3" style="border-color: #a4393a">
          <div class="" v-if="!noTravelBooked">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-7">
                <h3
                  class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
                >
                  Total Trip Estimate
                </h3>
              </div>
              <div class="column is-4" style="text-align: right;">
                <h3 class="is-size-5 has-text-grey">
                  {{ pricingInfo.total | formatPriceFromDollars }}
                </h3>
              </div>
              <div
                @click="priceExpanded = !priceExpanded"
                style="padding-left: 0"
                class="column is-1"
              >
                <b-icon
                  style="padding-top: 10px; cursor: pointer;"
                  icon="chevron-down"
                />
              </div>
            </div>
            <div v-if="priceExpanded">
              <hr />
              <div v-for="(flight, index) in pricingInfo.flight" :key="index">
                <span
                  class="is-block is-size-6 has-text-weight-bold my-2 segment-title-line"
                >
                  {{ flight.message }}
                </span>
                <span class="is-size-6">
                  Fare
                </span>
                <span class="is-block is-size-6 is-pulled-right">
                  {{ flight.fare | formatPriceFromDollars }} </span
                ><br />
                <div v-if="flight.seatFees > 0">
                  <span class="is-size-6 has-text-grey-light">
                    Seat Fees
                  </span>
                  <span class="is-size-6 is-pulled-right has-text-grey-light">
                    {{ flight.seatFees | formatPriceFromDollars }} </span
                  ><br />
                </div>
                <span class="is-size-6 has-text-grey-light">
                  Taxes
                </span>
                <span class="is-size-6 is-pulled-right has-text-grey-light">
                  {{ flight.tax | formatPriceFromDollars }}
                </span>

                <div class="estimated-total-line">
                  <span class="is-size-6">
                    Estimated Total
                  </span>
                  <span class="is-size-6 is-pulled-right mb-2">
                    <!-- {{ pricingInfo.flight.total + seatPricing.total| formatPrice}} -->
                    {{ flight.total | formatPriceFromDollars }}
                  </span>
                </div>
              </div>
              <div v-if="pricingInfo.car">
                <br />
                <span
                  class="is-block is-size-6 has-text-weight-bold mb-2 segment-title-line"
                >
                  {{ pricingInfo.car.message }}
                </span>
                <span class="is-size-6">
                  Rental charge ({{ pricingInfo.car.days }} days @
                  {{ pricingInfo.car.rate | formatPriceFromDollars }}/day)
                </span>
                <span class="is-block is-size-6 is-pulled-right">
                  {{ pricingInfo.car.fare | formatPriceFromDollars }} </span
                ><br />
                <div v-if="pricingInfo.car.tax">
                  <span class="is-size-6 has-text-grey-light">
                    Taxes
                  </span>
                  <span class="is-size-6 is-pulled-right has-text-grey-light">
                    {{ pricingInfo.car.tax | formatPriceFromDollars }} </span
                  ><br />
                </div>

                <div class="estimated-total-line">
                  <span class="is-size-6">
                    Estimated Total
                  </span>
                  <span class="is-size-6 is-pulled-right mb-2">
                    {{ pricingInfo.car.total | formatPriceFromDollars }}
                  </span>
                </div>
              </div>
              <div v-if="pricingInfo.hotel">
                <br />
                <span
                  class="is-block is-size-6 has-text-weight-bold mb-2 segment-title-line"
                >
                  {{ pricingInfo.hotel.message }}
                </span>
                <span v-if="pricingInfo.hotel.nights > 1" class="is-size-6">
                  Room charge ({{ pricingInfo.hotel.nights }} nights @
                  {{ pricingInfo.hotel.rate | formatPriceFromDollars }}/night)
                </span>
                <span v-else class="is-size-6">
                  Room charge (1 night)
                </span>
                <span class="is-block is-size-6 is-pulled-right">
                  {{ pricingInfo.hotel.fare | formatPriceFromDollars }} </span
                ><br />
                <div v-if="pricingInfo.hotel.tax">
                  <span class="is-size-6 has-text-grey-light">
                    Taxes
                  </span>
                  <span class="is-size-6 is-pulled-right has-text-grey-light">
                    {{ pricingInfo.hotel.tax | formatPriceFromDollars }} </span
                  ><br />
                </div>

                <div class="estimated-total-line">
                  <span class="is-size-6 estimated-total-line">
                    Estimated Total
                  </span>
                  <span class="is-size-6 is-pulled-right mb-2">
                    <b-tooltip
                      v-if="pricingInfo.hotel.currencyConvertedMessage"
                      class="is-size-5"
                      type="is-dark"
                      position="is-bottom"
                    >
                      <template v-slot:content>
                        {{ pricingInfo.hotel.currencyConvertedMessage }}
                      </template>
                      <b-icon
                        type="is-success"
                        icon="approximately-equal"
                        size="is-small"
                      >
                      </b-icon>
                    </b-tooltip>

                    {{ pricingInfo.hotel.total | formatPriceFromDollars }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="boxWithBorder mb-3" style="border-color: #a4393a">
          <h3
            class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold mb-2"
          >
            Trip Details
          </h3>

          <div class="is-size-7 mb-3">
            <div class="has-text-weight-bold">
              <span class="has-text-weight-bold is-size-6">{{
                selectedOffer.pricing.total | formatPriceFromDollars
              }}</span>
            </div>
            <div v-if="fareDescription !== ''" class="has-text-weight-bold">
              Fare class:
              <span class="has-text-grey has-text-weight-normal">{{
                fareDescription
              }}</span>
            </div>
            <div class="has-text-weight-bold">
              Passenger:
              <span class="has-text-grey has-text-weight-normal">
                {{ traveller.firstName }} {{ traveller.lastName }}</span
              >
            </div>
          </div>

          <div v-for="(leg, index) in ndcBooking.flight.journeys" :key="index">
            <div class="columns is-mobile">
              <div class="column is-2 is-mobile">
                <img
                  width="25"
                  :src="$helpers.airlineLogo(leg.airlineCode, 100, 100)"
                  class="mt-1"
                />
              </div>
              <div class="column is-10">
                <div
                  class="columns is-mobile is-gapless"
                  style="margin-bottom:8px"
                >
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.from }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.from) }}
                    </div>
                  </div>
                  <div class="column is-narrow">
                    <span class="is-size-7 mt-2 px-2 is-block">
                      <b-icon
                        icon="arrow-right"
                        class="has-text-grey-light"
                      ></b-icon>
                    </span>
                  </div>
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.to }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.to) }}
                    </div>
                  </div>
                </div>

                <span class="is-size-6 has-text-grey-light">{{
                  leg.legs[0].departingAt.date | formatDate
                }}</span>
                <br />
                <div class="is-size-6">
                  {{ leg.legs[0].departingAt.time | formatTime }} -
                  {{ leg.legs.slice(-1).pop().arrivingAt.time | formatTime }}
                </div>
                <OutOfPolicyTag
                  v-if="leg.travelPolicy"
                  class=""
                  :travelPolicy="leg.travelPolicy"
                ></OutOfPolicyTag>
                <b-collapse :open="false" aria-id="contentIdForA11y4">
                  <template #trigger="props">
                    <a
                      aria-controls="contentIdForA11y4"
                      :aria-expanded="props.open"
                      v-if="!props.open"
                      class="gant-text is-size-7"
                      >Show details</a
                    >
                    <a v-else class="gant-text is-size-7">Hide details</a>
                  </template>
                  <div style="padding-top: 10px;">
                    <FlightDetails :journeys="[leg]"></FlightDetails>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>

          <hr />
        </div>
      </div>
      <div
        class="column mr-3"
        :class="!pathMixin_isMeeting ? 'is-two-thirds' : ''"
      >
        <div
          class="pb-0 mb-0"
          :class="!pathMixin_isMeeting ? 'boxWithBorder' : 'box'"
          style="border-color: #a4393a"
        >
          <!-- TRAVELER INFORMATION -->

          <div>
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              <span class="is-pulled-left">Traveler Information</span>
            </h3>
            <div class="is-clearfix"></div>
          </div>
          <hr />

          <TravelerInformation
            v-model="profile"
            :label-position="labelPosition"
            :disabled="modifyingTrip"
          />

          <!-- Unaccompanied MINOR  -->
          <div class="mb-6" v-if="isUnaccompaniedMinor && !noTravelBooked">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Unaccompanied Minor
            </h3>
            <hr />
            <div class="mb-3">
              <p>
                Based on their date of birth and travel dates this traveler may
                be required to participate in the airline's unaccompanied minor
                program. Your booking request will be reviewed and processed by
                an agent and may result in additional service fees.
              </p>
              <p>
                <a
                  v-if="unaccompaniedMinorAirlineInfo.detailsUrl"
                  :href="unaccompaniedMinorAirlineInfo.detailsUrl"
                  target="_blank"
                  >View more details on the
                  {{ unaccompaniedMinorAirlineInfo.airlineName }} website</a
                >
              </p>
            </div>
            <b-field>
              <b-checkbox
                type="is-primary"
                v-model="unaccompaniedMinor.agreeToFees"
                >I have read and understand the Unaccompanied Minor policy
                stated above.</b-checkbox
              >
            </b-field>
            <b-field label="Parent / Guardian Name">
              <b-input
                v-model="unaccompaniedMinor.parentName"
                validation-message="Please enter a valid name"
                pattern="[a-zA-Z]*"
                required
              ></b-input>
            </b-field>
            <b-field label="Parent / Guardian Phone Number">
              <b-input
                v-model="unaccompaniedMinor.parentPhone"
                v-cleave="masks.phone"
                required
              ></b-input>
            </b-field>
          </div>

          <!--  FREQUENT TRAVEL PROGRAMS  -->
          <div class="mb-6" v-if="!noTravelBooked">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Frequent Travel Programs
            </h3>
            <hr />
            <div v-for="(program, index) in travelerPrograms" :key="index">
              <b-field
                :label="program.providerName"
                :label-position="labelPosition"
                class="mb-5"
              >
                <b-input v-model="program.accountNumber"></b-input>
              </b-field>
            </div>
          </div>

          <!-- GUEST TRAVELERS -->

          <div v-for="(guest, index) in guestTravelers" :key="index">
            <div>
              <h3
                class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
              >
                <span class="is-pulled-left"
                  >Guest Passenger #{{ index + 1 }}</span
                >
              </h3>
              <div class="is-clearfix"></div>
            </div>
            <hr />

            <TravelerInformation
              :value="guest.profile"
              :label-position="labelPosition"
              :disabled="modifyingTrip"
              @input="updateGuestProfile"
            />

            <div class="mb-6">
              <h3
                class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
              >
                Frequent Travel Programs
              </h3>
              <hr />
              <div v-for="(program, idx) in guest.travelerPrograms" :key="idx">
                <b-field
                  :label="program.providerName"
                  :label-position="labelPosition"
                  class="mb-5"
                >
                  <b-input v-model="program.accountNumber"></b-input>
                </b-field>
              </div>
            </div>
          </div>

          <!-- PAYMENT DETAILS -->
          <div class="mb-6" v-if="!paymentMethodMeeting && !noTravelBooked">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Your Payment Details
            </h3>
            <hr />

            <UserAirNotifications
              class="mt-3 mb-3"
              v-if="hasMatchingUnusedTicket"
            />

            <div class="field" v-if="!customPaymentChosen">
              <div class="is-flex is-flex-wrap-wrap">
                <b-field
                  v-for="(payment, idx) in payments"
                  :key="`${idx} ${payment.id}`"
                  class="is-flex-grow-1 ml-1 mr-1"
                >
                  <FieldsetBox>
                    <template #header>
                      <span class="textOnly">
                        <img width="35" :src="getCardLogo(payment.brand)" />
                      </span>
                    </template>
                    <template #content>
                      <div class="columns is-mobile">
                        <div class="column is-1">
                          <b-radio
                            v-model="selectedPayment"
                            :name="payment.displayName"
                            :native-value="payment"
                            class="pt-1"
                          >
                          </b-radio>
                        </div>
                        <div class="column is-11 has-text-left">
                          <div class="has-text-weight-bold">
                            {{ payment.displayName }}
                          </div>
                          <div class="has-text-grey">
                            Ending in {{ payment.last4 }}
                          </div>
                          <div class="has-text-grey-light is-size-7">
                            Expires {{ payment.expirationMonth }}/{{
                              payment.expirationYear
                            }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </FieldsetBox>
                </b-field>
              </div>
            </div>
            <div v-if="allowNewPaymentMethod">
              <a class="teal-text" @click="customPaymentChosen = true"
                ><u>+ Add a new card</u></a
              >
            </div>
          </div>
          <!--  COMPANY CARD IS PAYING  -->
          <div class="mb-6" v-else-if="!noTravelBooked">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Payment Details
            </h3>
            <hr />
            A company card is paying for this trip.
          </div>

          <!-- OUT OF POLICY EXPLANATION -->
          <div class="mb-6" v-if="policyTriggered">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Travel Policy and Approvals
            </h3>
            <hr />
            <p class="gant-text has-text-weight-bold mb-4">
              Please explain why below booking(s) is/are out of policy.
            </p>
            <div class="field">
              <!-- <div class style="color: gray; margin-bottom: 0px; font-size: 12px;">
                <div>
                  The following trip segments are out of policy. If necessary, please provide notes for the approver.
                </div>
              </div>
              <br /> -->
              <div v-if="ndcBooking.flight.travelPolicy">
                <div
                  v-if="
                    this.ndcBooking.flight.travelPolicy.summary
                      .rulesTriggeredCount != 0
                  "
                >
                  Your flight reservation with
                  {{
                    $globals.vendors.airlines[
                      ndcBooking.flight.journeys[0].legs[0].marketingAirline
                        .code
                    ]
                  }}
                  <b
                    v-if="
                      ndcBooking.flight.travelPolicy.summary
                        .mostStrictApprovalRequired == 'soft'
                    "
                    >triggers a manager notification</b
                  >
                  <b
                    v-if="
                      ndcBooking.flight.travelPolicy.summary
                        .mostStrictApprovalRequired == 'hard'
                    "
                    >needs manager approval</b
                  >
                  <div class="content">
                    <ul>
                      <li
                        class="is-size-7"
                        style="padding-left: 10px;"
                        v-for="item in ndcBooking.flight.travelPolicy
                          .rulesTriggered"
                        :key="`A ${item.message}`"
                      >
                        {{ item.message }}
                      </li>
                    </ul>
                  </div>
                  <b-field>
                    <b-input
                      placeholder="Notes for approver / logs"
                      size="is-small"
                      v-model="policyNotes.air"
                      maxlength="200"
                      type="textarea"
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </div>
          </div>

          <!-- REPORTING QUESTIONS -->
          <div
            class="mb-6"
            v-if="
              isBusinessTrip &&
                filteredQuestions.length > 0 &&
                !noTravelBooked &&
                !modifyingTrip
            "
          >
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Reporting Questions
            </h3>
            <hr />
            <div v-for="question in filteredQuestions" :key="question.id">
              <Questions v-model="question.answer" :udidQuestion="question" />
            </div>
          </div>

          <!-- OPTIONAL ITEMS -->
          <div class="mb-6">
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Optional Items
            </h3>
            <hr />
            <b-collapse :open="false" aria-id="contentIdForA11y1">
              <template #trigger="props">
                <b-button
                  type="is-text"
                  class="gant-text"
                  aria-controls="contentIdForA11y1"
                  :aria-expanded="props.open"
                >
                  {{
                    props.open
                      ? "CANCEL: Special Request"
                      : "+ Add a Special Request to Agent"
                  }}
                </b-button>
              </template>
              <div class="">
                <div class="content mt-2 ">
                  <div class="mb-3">
                    Adding special requests will delay the processing of your
                    itinerary until your requests can be reviewed and processed
                    by an agent and may result in additional service fees.
                  </div>
                  <div class="field">
                    <b-field>
                      <b-input
                        v-model="specialRequest.text"
                        maxlength="200"
                        type="textarea"
                        placeholder="Your Special Request"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </b-collapse>
            <b-collapse
              v-if="!modifyingTrip"
              :open="false"
              aria-id="contentIdForA11y1"
            >
              <template #trigger="props">
                <b-button
                  type="is-text"
                  class="gant-text"
                  aria-controls="contentIdForA11y1"
                  :aria-expanded="props.open"
                >
                  {{
                    props.open
                      ? "CANCEL: Trip Description"
                      : "+ Add a Trip Name and Description"
                  }}
                </b-button>
              </template>
              <div class="">
                <div class="content mt-2 ">
                  <div class="field">
                    <b-field label="Name Your Trip (optional)">
                      <b-input v-model="tripName"></b-input>
                    </b-field>
                  </div>
                  <div class="field">
                    <b-field label="Describe Your Trip (optional)">
                      <b-input
                        v-model="tripDescription"
                        maxlength="200"
                        type="textarea"
                      ></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </b-collapse>
            <b-collapse
              v-if="!modifyingTrip"
              :open="false"
              aria-id="contentIdForA11y1"
            >
              <template #trigger="props">
                <b-button
                  type="is-text"
                  class="gant-text"
                  aria-controls="contentIdForA11y1"
                  :aria-expanded="props.open"
                >
                  {{
                    props.open
                      ? "CANCEL: Email Notifications"
                      : "+ Add Email Notifications"
                  }}
                </b-button>
              </template>
              <div class="">
                <div class="content mt-2 ">
                  <div class="mb-5">
                    A copy of the trip itinerary will be sent to:
                    <strong>{{ profile.email }}</strong>
                  </div>
                  <div class="field">
                    <b-field label="Notify Me" v-if="bookingForSomeoneElse">
                      <b-checkbox
                        type="is-primary"
                        v-model="ccEmailActiveUser"
                        >{{ activeUser.email }}</b-checkbox
                      >
                    </b-field>
                    <b-field
                      label="Additional Email Address to Notify (optional)"
                    >
                      <b-input type="email" v-model="ccEmail"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>

          <!-- Review Rules and Details -->
          <div class="" v-if="oneWayFlightBooked">
            <!-- <div class="box"> -->
            <h3
              class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
            >
              Review Rules and Details
            </h3>
            <hr />
            <div class="is-flex is-align-content-center">
              <div class="field mr-1" v-if="oneWayFlightBooked">
                <b-button
                  size="is-small"
                  type="is-warning"
                  @click="fareRulesModal(ndcBooking.flight.journeys)"
                  rounded
                  >View Flight Fare Rules</b-button
                >
              </div>
              <div class="field mr-1"></div>
              <div class="field mr-1"></div>
            </div>
          </div>

          <!--  PREVIEW NOTIFICATION -->
          <b-notification
            v-if="previewMode"
            type="is-default"
            class="mb-2 mt-2 has-text-info"
            :closable="false"
          >
            <strong>Heads up!</strong> You are in "{{ previewMode }}" preview
            mode. Your reservation will not be created.
          </b-notification>

          <!--  COMPLETE BOOKING BUTTONS -->
          <div class="bookingButtonContainer">
            <div class="buttonContainer">
              <div class="bookingButtons">
                <div>
                  <b-button
                    size="is-medium"
                    type="is-gant"
                    class="is-hidden-touch"
                    icon-left="lock"
                    :disabled="checkout_pending || !allowConfirm"
                    @click="checkInputs()"
                    style=""
                    :style="
                      !pathMixin_isMeeting
                        ? 'margin:auto;'
                        : 'margin: -45px auto auto auto;'
                    "
                    expanded
                  >
                    <h5>
                      <span class="is-hidden-mobile">Complete My Booking</span>
                    </h5>
                    <h5>
                      <span class="is-hidden-desktop is-hidden-tablet"
                        >Book</span
                      >
                    </h5>
                  </b-button>
                  <b-button
                    size="is-medium"
                    type="is-gant"
                    expanded
                    icon-left="lock"
                    class="is-hidden-desktop"
                    :disabled="checkout_pending || !allowConfirm"
                    @click="checkInputs()"
                    style="margin:auto;"
                  >
                    <h5>
                      <span class="is-hidden-mobile">Complete My Booking</span>
                    </h5>
                    <h5>
                      <span class="is-hidden-desktop is-hidden-tablet"
                        >Book</span
                      >
                    </h5>
                  </b-button>
                </div>
              </div>
            </div>
            <img
              src="/images/SVGs/Checkout_group.svg"
              alt=""
              style="z-index: 10;"
            />
          </div>

          <b-notification
            type="is-danger is-light"
            class="mt-5 my-3"
            v-if="inputErrors"
            :closable="false"
          >
            <h4 class="is-size-5">Please correct the following errors:</h4>
            <div class="content">
              <ul>
                <li
                  v-for="(validationError, index) in inputErrors"
                  :key="index"
                >
                  {{ validationError }}
                </li>
              </ul>
            </div>
          </b-notification>
        </div>
        <!--  END OF COLUMN -->
      </div>
      <div class="column" v-if="isDesktop">
        <b-notification
          :type="countdown > 0 ? 'is-warning' : 'is-danger'"
          :closable="false"
          position="is-top-right"
          has-icon
          icon="clock"
          icon-size="is-small"
        >
          <div v-if="countdown > 0" class="is-size-5 mt-2">
            Hurry! This fare expires in {{ minutes }} minutes
            {{ seconds }} seconds.
          </div>
          <div v-else class="is-size-5 mt-2">
            Sorry, this fare has expired.
          </div>
        </b-notification>

        <b-message
          title="Airline Direct (NDC) Fare"
          type="is-success"
          aria-close-label="Close message"
        >
          <ul>
            <li>
              This fare is a direct airline fare and may contain special
              pricing.
            </li>
            <li>
              NDC fares do not allow car rentals or hotel stays to be added 
              to the reservation at the time of booking. Once you've finalized 
              the reservation, you may book a car and/or hotel for this trip in 
              two ways: 1) add to the existing reservation through 'My Trips' 
              or 2) complete a new and separate reservation. There is no 
              additional charge(s) for booking car and/or hotel utilizing either 
              of these options.
            </li>
            <li>
              <strong>PLEASE NOTE:</strong> Gant Travel does not charge an NDC
              service surcharge for NDC reservations booked through the online
              tool. However, should an NDC reservation that originates online
              require the intervention or assistance of a Gant agent after
              booking (i.e.: exchanges, itinerary changes, etc.), the NDC
              service surcharge of $24.00 will be charged at that time. This fee
              is in addition to your contracted agent-assist fees.
            </li>
          </ul>
        </b-message>

        <div
          class="mb-3"
          :class="!pathMixin_isMeeting ? 'boxWithBorder' : 'box'"
          style="border-color: #a4393a"
        >
          <div class="" v-if="!noTravelBooked">
            <div class="columns is-mobile is-vcentered">
              <div class="column is-7">
                <h3
                  class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold"
                >
                  Total Trip Estimate
                </h3>
              </div>
              <div class="column is-4" style="text-align: right;">
                <h3 class="is-size-5 has-text-grey">
                  {{ pricingInfo.total | formatPriceFromDollars }}
                </h3>
              </div>
              <div
                @click="priceExpanded = !priceExpanded"
                style="padding-left: 0"
                class="column is-1"
              >
                <b-icon
                  style="padding-top: 10px; cursor: pointer;"
                  icon="chevron-down"
                />
              </div>
            </div>
            <div v-if="priceExpanded">
              <hr />
              <div v-for="(flight, index) in pricingInfo.flight" :key="index">
                <span
                  class="is-block is-size-6 has-text-weight-bold my-2 segment-title-line"
                >
                  {{ flight.message }}
                </span>
                <span class="is-size-6">
                  Fare
                </span>
                <span class="is-block is-size-6 is-pulled-right">
                  {{ flight.fare | formatPriceFromDollars }} </span
                ><br />
                <div v-if="flight.seatFees > 0">
                  <span class="is-size-6 has-text-grey-light">
                    Seat Fees
                  </span>
                  <span class="is-size-6 is-pulled-right has-text-grey-light">
                    {{ flight.seatFees | formatPriceFromDollars }} </span
                  ><br />
                </div>
                <span class="is-size-6 has-text-grey-light">
                  Taxes
                </span>
                <span class="is-size-6 is-pulled-right has-text-grey-light">
                  {{ flight.tax | formatPriceFromDollars }}
                </span>

                <div class="estimated-total-line">
                  <span class="is-size-6">
                    Estimated Total
                  </span>
                  <span class="is-size-6 is-pulled-right mb-2">
                    <!-- {{ pricingInfo.flight.total + seatPricing.total| formatPrice}} -->
                    {{ flight.total | formatPriceFromDollars }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-3"
          :class="!pathMixin_isMeeting ? 'boxWithBorder' : 'box'"
          style="border-color: #a4393a"
        >
          <h3
            class="is-size-6 is-uppercase has-text-grey-darker has-text-weight-bold mb-2"
          >
            Trip Details
          </h3>

          <div class="is-size-7 mb-3">
            <div class="has-text-weight-bold">
              <span class="has-text-weight-bold is-size-6">{{
                selectedOffer.pricing.total | formatPriceFromDollars
              }}</span>
            </div>
            <div v-if="fareDescription !== ''" class="has-text-weight-bold">
              Fare class:
              <span class="has-text-grey has-text-weight-normal">{{
                fareDescription
              }}</span>
            </div>
            <div class="has-text-weight-bold">
              Passenger:
              <span class="has-text-grey has-text-weight-normal">
                {{ traveller.firstName }} {{ traveller.lastName }}</span
              >
            </div>
          </div>

          <div v-for="(leg, index) in ndcBooking.flight.journeys" :key="index">
            <div class="columns is-mobile">
              <div class="column is-2 is-mobile">
                <img
                  width="25"
                  :src="$helpers.airlineLogo(leg.airlineCode, 100, 100)"
                  class="mt-1"
                />
              </div>
              <div class="column is-10">
                <div
                  class="columns is-mobile is-gapless"
                  style="margin-bottom:8px"
                >
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.from }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.from) }}
                    </div>
                  </div>
                  <div class="column is-narrow">
                    <span class="is-size-7 mt-2 px-2 is-block">
                      <b-icon
                        icon="arrow-right"
                        class="has-text-grey-light"
                      ></b-icon>
                    </span>
                  </div>
                  <div class="column is-narrow">
                    <div class="has-text-weight-bold">
                      {{ leg.to }}
                    </div>
                    <div class="is-size-7 has-text-grey">
                      {{ getAirportLocation(leg.to) }}
                    </div>
                  </div>
                </div>

                <span class="is-size-6 has-text-grey-light">{{
                  leg.legs[0].departingAt.date | formatDate
                }}</span>
                <br />
                <div class="is-size-6">
                  {{ leg.legs[0].departingAt.time | formatTime }} -
                  {{ leg.legs.slice(-1).pop().arrivingAt.time | formatTime }}
                </div>
                <OutOfPolicyTag
                  v-if="leg.travelPolicy"
                  class=""
                  :travelPolicy="leg.travelPolicy"
                ></OutOfPolicyTag>
                <b-collapse :open="false" aria-id="contentIdForA11y4">
                  <template #trigger="props">
                    <a
                      aria-controls="contentIdForA11y4"
                      :aria-expanded="props.open"
                      v-if="!props.open"
                      class="gant-text is-size-7"
                      >Show details</a
                    >
                    <a v-else class="gant-text is-size-7">Hide details</a>
                  </template>
                  <div style="padding-top: 10px;">
                    <FlightDetails :journeys="[leg]"></FlightDetails>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      v-model="pnr_is_pending"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-label="PNR Pending"
      aria-modal
      :canCancel="[]"
    >
      <template #default="props">
        <PNRPending
          v-if="pnr_is_pending"
          :key="pending_pnr.bookingKey"
          :payload="pending_pnr"
          @close="props.close"
          @complete="pnrComplete"
        />
      </template>
    </b-modal>
    <b-modal
      v-model="customPaymentChosen"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-label="Add card Modal"
      aria-modal
      :canCancel="['escape', 'outside', 'x']"
    >
      <template #default="props">
        <AddCardModal @close="props.close" @update="addCard"></AddCardModal>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import Cleave from "cleave.js";
const cleave = {
  name: "cleave",
  bind(el, binding) {
    const input = el.querySelector("input");
    input._vCleave = new Cleave(input, binding.value);
  },
  unbind(el) {
    const input = el.querySelector("input");
    input._vCleave.destroy();
  },
};
import modalMixin from "../../mixins/modalMixin";
import bookingMixin from "../../mixins/bookingMixin";
import meetingsMixin from "../../mixins/meetingsMixin";
import SmallFlightItinerary from "../Itinerary/SmallFlightItinerary";
import ItineraryFlight from "../Itinerary/ItineraryFlight";
import Questions from "../Itinerary/Questions";
import PNRPending from "../Itinerary/PNR_Pending";
import AddCardModal from "../CreditCardEntry/AddCardModal";
import FieldsetBox from "../UI/FieldsetBox";
import UserAirNotifications from "../User/UserAirNotifications";
import PreviousTripItinerary from "@/components/Trip/PreviousTripItinerary";
import TravelerInformation from "@/components/TravelerInformation";
import FlightDetails from "../BookTravel/Air/FlightDetails.vue";

export default {
  name: "NDCCheckout",
  directives: {
    cleave,
  },
  mixins: [modalMixin, bookingMixin, meetingsMixin],
  components: {
    //SmallFlightItinerary,
    FlightDetails,
    Questions,
    PNRPending,
    AddCardModal,
    FieldsetBox,
    UserAirNotifications,
    TravelerInformation,
  },

  data: function() {
    return {
      countdown: 0,
      display_full: false,
      checkout_pending: false,
      previewMode: this.$appConfig.previewMode, // options: null, 'success', 'failure'
      priceExpanded: false,
      inputErrors: false,
      unaccompaniedMinor: {},
      unaccompaniedMinorAirlineDetailsUrl: null,
      travelerPrograms: [],
      masks: {
        creditCard: { creditCard: true },
        numeral: {
          numeral: true,
          numeralThousandsGroupStyle: "thousand",
          prefix: "$ ",
        },
        date: {
          date: true,
          datePattern: ["m", "y"],
        },
        dob: {
          date: true,
          delimiter: "/",
          datePattern: ["m", "d", "Y"],
        },
        phone: {
          phone: true,
          phoneRegionCode: "US",
          delimiter: "-",
        },
      },
      customPaymentChosen: false,
      first_name: "",
      tripName: "",
      tripDescription: "",
      allowSpecialRequests: true,
      specialRequest: {
        activated: false,
        text: "",
      },
      loading: true,
      //profile: {},
      policyNotes: { air: "", hotel: "", car: "" },
      last_name: "",
      customPayment: {
        cardholderName: "",
        expDate: { month: "", year: "" },
        cardNum: "",
      },
      selectedPayment: "",
      selectedTicket: "",
      checkedPrice: null,
      hover: false,
      value: "",
      priceChanged: false,
      rawValue: "",
      // questions: [{question: "What is the purpose of this trip?", options: ['Personal','Corporate'], type:"mc"},
      //             {question: "Additional Comments", options: null, type:"open"}],
      questions: [],
      ccEmailActiveUser: null,
      ccEmail: null,
      labelPosition: "on-border",
      isDesktop: true,
    };
  },
  computed: {
    profile: {
      get() {
        return this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ];
      },
      set(value) {
        this.$store.commit(
          "travellersAndTrips/setCurrentTravellerProfile",
          value
        );
      },
    },
    minutes() {
      return Math.floor(this.countdown / 60);
    },
    seconds() {
      return this.countdown % 60;
    },
    selectedOffer() {
      return this.$store.state.bookTravel.ndcBooking.selectedOffer;
    },
    ndcBooking() {
      return this.$store.state.bookTravel.ndcBooking;
    },
    fareDescription() {
      return this.selectedOffer.journeyList[0].bookingClass;
    },
    noTravelBooked() {
      return this.$helpers.isEmptyObject(this.ndcBooking.flight);
    },
    legs() {
      var legs = [];
      var journey;
      var leg;
      for (journey of this.ndcBooking.flight.journeys) {
        for (leg of journey.legs) {
          legs.push(leg);
        }
      }
      return legs;
    },
    pricingInfo() {
      var price = { flight: false, total: 0 };
      if (this.selectedAirlines.length > 0) {
        price.flight = [];
        price.flight.push(this.calculateFlightCost(price, this.ndcBooking));
        price.total += price.flight.reduce((sum, i) => sum + i.total, 0);
      }

      return price;
    },
    selectedAirlines() {
      var airlines = [];
      if (!this.ndcBooking.flight.journeys) {
        return [...new Set(airlines)];
      }
      var journey;
      var leg;
      for (journey of this.ndcBooking.flight.journeys) {
        for (leg of journey.legs) {
          airlines.push(leg.marketingAirline.code);
        }
      }
      return [...new Set(airlines)];
    },

    nothingBooked() {
      return Object.keys(this.ndcBooking.flight).length;
    },
    multiLegs() {
      return this.ndcBooking.flight.journeys.length > 1;
    },
    booking_queue() {
      return this.$store.state.pnr.queue;
    },
    pending_pnr() {
      return this.$store.state.pnr.pending;
    },
    pnr_is_pending() {
      return Object.keys(this.pending_pnr).length !== 0;
    },
    allowConfirm() {
      return true;
    },
    isUnaccompaniedMinor() {
      // No flight, return false
      if (!this.ndcBooking.flight) return false;

      // No flight journeys
      if (this.ndcBooking.flight.journeys === undefined) return false;

      // Get the date of the first flight
      let dateOfFirstFlight = this.ndcBooking.flight.journeys[0].startDate;

      let airlineDetails = this.unaccompaniedMinorAirlineInfo;

      //// console.log(airlineDetails)

      let absoluteMinAge = airlineDetails.ageWhereRequired.min;
      let absoluteMaxAge = airlineDetails.ageWhereRequired.max;

      if (airlineDetails.ageWhereOptional.max) {
        absoluteMaxAge = airlineDetails.ageWhereOptional.max;
      }

      let dateOfBirth = null;
      let firstTravelDate = null;

      if (dateOfFirstFlight) {
        firstTravelDate = moment(dateOfFirstFlight);
      }

      // Get traveler's date of birth
      if (this.profile.dateOfBirth) {
        dateOfBirth = moment(this.profile.dateOfBirth).format("MM-DD-YYYY");
      }

      // Check traveler's age on date of first flight
      if (dateOfBirth && firstTravelDate) {
        let ageInYears = firstTravelDate.diff(dateOfBirth, "years");

        //// console.log(ageInYears, absoluteMinAge, absoluteMaxAge)

        if (ageInYears >= absoluteMinAge && ageInYears <= absoluteMaxAge)
          return true;
      }

      return false;
    },
    unaccompaniedMinorAirlineInfo() {
      // Set defaults
      let airlineDetails = {
        ageWhereRequired: {
          min: 5,
          max: 14,
        },
        ageWhereOptional: {
          min: null,
          max: null,
        },
        airlineName: "airline",
        detailsUrl: null,
      };

      // No flight, return false
      if (!this.ndcBooking.flight) return airlineDetails;

      // No flight journeys
      if (this.ndcBooking.flight.journeys === undefined) return airlineDetails;

      let airlineCode = this.ndcBooking.flight.journeys[0].airlineCode;

      let unaccompaniedMinorAirlineDetails = this.$store.state
        .travellersAndTrips.unaccompaniedMinorAirlineDetails;

      let matchingAirlineDetails = unaccompaniedMinorAirlineDetails.filter(
        (item) => {
          return item.airlineCode == airlineCode;
        }
      );

      if (matchingAirlineDetails.length == 1) {
        airlineDetails = matchingAirlineDetails[0];
      }

      return airlineDetails;
    },
    /*
    travelerPrograms() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].travelerPrograms;
    },
    */
    paymentMethodMeeting() {
      if (this.$store.state.meetings.meetingInfo) {
        return this.$store.state.meetings.meetingInfo.meeting.paymentMethodId;
      }

      return null;
    },
    allowNewPaymentMethod() {
      let tripType = this.$store.getters["travellersAndTrips/getTravellers"]
        .tripType;

      if (tripType == "personal") return true;

      if (
        tripType == "personal" ||
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy == null
      )
        return true;

      if (
        tripType != "personal" &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy != null &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy.allowPersonalPaymentMethods == true
      )
        return true;

      // If in meeting mode and no payment method on the meeting
      // TODO: also handle the case where the payment method is configured at the meeting attendee level
      if (this.pathMixin_isMeeting && this.paymentMethodMeeting == null) {
        return true;
      }

      return false;
    },
    payments() {
      let cards = [];
      let personalCards = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].paymentMethods;
      // // console.log('getCurrentTravellerProfile', this.$store.getters['travellersAndTrips/getCurrentTravellerProfile']);
      //// console.log('personalCards', personalCards);

      let tripType = this.$store.getters["travellersAndTrips/getTravellers"]
        .tripType;

      // No travel policy > personal only
      if (
        tripType === "personal" ||
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy === null
      ) {
        cards = personalCards;
      }
      // Travel policy, allow personal cards > add cards to list
      if (
        tripType !== "personal" &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy !== null &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy.allowPersonalPaymentMethods === true
      ) {
        cards = personalCards;
      }
      // Travel policy, corp ghost card set > add to list
      if (
        tripType !== "personal" &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy !== null &&
        this.$store.getters["travellersAndTrips/getCurrentTravellerProfile"]
          .travelPolicy.corporateGhostCard !== null
      ) {
        let card = this.$store.getters[
          "travellersAndTrips/getCurrentTravellerProfile"
        ].travelPolicy.corporateGhostCard;

        card.displayName = "Corporate Ghost Card";
        cards.unshift(card);
      }

      // Meeting mode, without a payment method set for the meeting as whole
      if (this.pathMixin_isMeeting && this.paymentMethodMeeting == null) {
        cards = personalCards;
      }

      // No cards > display error or auto-open add card section
      //// console.log('cards: ' + cards)
      return cards;
    },
    hasMatchingUnusedTicket() {
      var hasMatch = false;
      var airlineCodes = this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].unusedTicketAirlines;
      if (airlineCodes) {
        for (let airlineCode of airlineCodes) {
          if (this.selectedAirlines.includes(airlineCode)) {
            hasMatch = true;
          }
        }
      }
      return hasMatch;
    },
    policyTriggered() {
      var rules = 0;
      if (this.ndcBooking.flight.travelPolicy) {
        rules += this.ndcBooking.flight.travelPolicy.summary
          .rulesTriggeredCount;
      }
      return rules > 0;
    },
    traveller() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    activeUser() {
      return this.$store.getters["app/getActiveUser"];
    },
    bookingForSomeoneElse() {
      return this.activeUser.id != this.traveller.id;
    },
    oneWayFlightBooked() {
      if (this.ndcBooking.flight.journeys) {
        return this.ndcBooking.flight.journeys.length == 1;
      }
      return false;
    },
    isBusinessTrip() {
      return this.tripType == "business";
    },
    seatPricing() {
      try {
        var flight = this.ndcBooking.flight;
        var seatPrice = [];
        var total = 0;
        for (var journey of flight.journeys) {
          for (var leg of journey.legs) {
            if (leg.selectedSeat) {
              if (leg.selectedSeat.price) {
                total += leg.selectedSeat.price.total;
                seatPrice.push(leg.selectedSeat);
              }
            }
          }
        }
        return { seats: seatPrice, total: total };
      } catch {
        return { seats: [], total: 0 };
      }
    },
    /*
    req() {
      return this.$store.state.pnr.pnr.req;
    },
    */
    tripType() {
      let tripType = this.$store.getters["travellersAndTrips/getTravellers"]
        .tripType;

      return tripType;
    },
    isPersonalTrip() {
      return this.tripType == "personal";
    },
    guestTravelers() {
      return this.$store.state.bookTravel.guests;
    },
    /*
    relevantPrograms() {
      return this.findRelevantPrograms(this.travelerPrograms);
    },
    */
    dobFormatted() {
      return moment(this.profile.dateOfBirth).format("MM/DD/YYYY");
    },
    filteredQuestions() {
      let questions = this.questions;
      let filteredQuestions = [];

      if (this.pathMixin_isMeeting) {
        filteredQuestions = questions.filter((question) => {
          return question.showInTripCircuitMeetings;
        });
      } else {
        filteredQuestions = questions.filter((question) => {
          return question.showInTripCircuitNonMeetings;
        });
      }

      return filteredQuestions;
    },
  },
  methods: {
    updateGuestProfile(profile) {
      this.$store.dispatch("bookTravel/updateGuestProfile", {
        guest: this.profile,
        index: this.guestIndex,
      });
    },
    countdownTimer() {
      if (this.countdown > 0) {
        setTimeout(() => {
          this.countdown -= 1;
          this.countdownTimer();
        }, 1000);
      }
    },
    getAirportLocation(airportCode) {
      let airport = this.$globals.airports.find(
        ({ code }) => code == airportCode
      );
      if (!airport) return null;
      return airport.city + ", " + airport.state;
    },
    confirmMeetingRegistration() {
      this.$router.push({ path: "/meetings/confirmation" });
    },
    checkInputs() {
      var messages = [];
      if (!this.selectedPayment && !this.paymentMethodMeeting) {
        messages.push("Please select a payment method");
      }

      if (
        !(
          this.profile.firstName &&
          this.profile.lastName &&
          this.profile.dateOfBirth &&
          this.profile.mobilePhone &&
          this.profile.email &&
          this.profile.gender
        )
      ) {
        messages.push("Please enter missing passenger details");
      }

      if (!this.profile.dateOfBirth) {
        messages.push("Date of Birth is required");
      }

      if (!this.$date.dobValidate(this.profile.dateOfBirth)) {
        messages.push("Date of birth seems to be in the wrong format");
      }

      if (this.checkUdids() > 0 && !this.modifyingTrip) {
        messages.push("Please answer required reporting questions");
      }

      if (this.isUnaccompaniedMinor && !this.unaccompaniedMinor.agreeToFees) {
        messages.push(
          "Please indicate you have read and understand the Unaccompanied Minor policy"
        );
      }

      if (this.isUnaccompaniedMinor && !this.unaccompaniedMinor.parentName) {
        messages.push(
          "Please provide a parent or guardian name in the Unaccompanied Minor section"
        );
      }

      if (this.isUnaccompaniedMinor && !this.unaccompaniedMinor.parentPhone) {
        messages.push(
          "Please provide a parent or guardian phone number in the Unaccompanied Minor section"
        );
      }

      if (messages.length > 0) {
        this.inputErrors = messages;
      } else {
        // console.log('proceed with booking')
        this.submitCheckout();
      }
    },
    calculateFlightCost(cost, solution) {
      cost = {};
      cost.seatFees = 0;
      for (var i = 0; i < solution.flight.journeys.length; i++) {
        for (var j = 0; j < solution.flight.journeys[i].legs.length; j++) {
          if (solution.flight.journeys[i].legs[j].selectedSeat) {
            if (solution.flight.journeys[i].legs[j].selectedSeat.price) {
              cost.seatFees +=
                solution.flight.journeys[i].legs[j].selectedSeat.price.total;
            }
          }
        }
      }

      if (solution.flight.journeys.length == 1) {
        cost.message =
          "Flight (" +
          solution.flight.originAirportCode +
          ", " +
          solution.flight.destinationAirportCode +
          ")";
      } else if (solution.flight.journeys.length == 2) {
        cost.message =
          "Round Trip Flight (" +
          solution.flight.originAirportCode +
          ", " +
          solution.flight.destinationAirportCode +
          ")";
      } else {
        cost.message = "Multi-City Flight";
      }

      cost.tax = this.selectedOffer.pricing.tax;
      cost.fare = this.selectedOffer.pricing.fare;
      cost.total = this.selectedOffer.pricing.total;
      cost.total += cost.seatFees;
      return cost;
    },
    //search traveler's programs for those that match the air/car/hotel vendors used in the booking
    findRelevantPrograms(travelerPrograms = []) {
      let programs = [];

      // Air
      for (let airlineCode of this.selectedAirlines) {
        let program = {
          type: "air",
          providerCode: airlineCode,
          providerName: this.$globals.vendors.airlines[airlineCode],
          accountNumber: null,
        };

        let matchingProgram = travelerPrograms.find((i) => {
          return i.providerCode == airlineCode;
        });

        if (matchingProgram) {
          program.accountNumber = matchingProgram.accountNumber;
        }

        programs.push(program);
      }

      return programs;
    },
    checkUdids() {
      var unanswered = 0;
      for (let i = 0; i < this.filteredQuestions.length; i++) {
        if (
          this.filteredQuestions[i].isRequired &&
          (!this.filteredQuestions[i].answer ||
            this.filteredQuestions[i].answer == [])
        ) {
          unanswered += 1;
        }
      }
      // // console.log(this.filteredQuestions)
      // // console.log(unanswered)
      return unanswered;
    },
    addCard(val) {
      // // console.log('#########################')
      // // console.log(val)
      //this.$store.commit('travellersAndTrips/ADD_PAYMENT', val)

      this.$store.dispatch("travellersAndTrips/addPayment", val);
      this.selectedPayment = val;
    },
    getCardLogo(name) {
      // console.log('card name', name);
      if (name) {
        return "/images/" + name.toLowerCase() + ".png";
      } else {
        return "/images/cc.png";
      }
    },
    /*
    loadProfile() {
      this.profile = JSON.parse(
        JSON.stringify(this.$globals.currentTravellerProfile)
      );
      this.getUdids();
    },*/
    getUdids() {
      if (!this.isBusinessTrip) {
        this.loading = false;
        return;
      }
      var raw = {
        accountId: this.profile.account.id,
      };

      this.$app.huddleLabsServerCall("profile/udids", raw).then((result) => {
        this.questions = result.data;
        this.loading = false;
      });
    },
    saveRegistrationTime() {
      var raw = {
        id: this.$store.state.meetings.meetingInfo.attendeeId,
        events: ["registrationCompleted"],
      };
      this.$app.huddleLabsServerCall("meetings/attendee/save", raw);
    },
    hoverChange() {
      this.hover = !this.hover;
    },
    proceed() {
      this.submitCheckout();
      this.$router.push({ path: "/pnr" });
    },
    itinerary() {
      this.$router.push({ path: "/itinerary" });
    },
    async getFareRules(flight) {
      return flight;
    },
    onInput(event) {
      this.rawValue = event.target._vCleave.getRawValue();
      this.value = event.target._vCleave.getFormattedValue();
    },
    getPrice() {
      let price = 0;
      // if (this.checkedPrice) {
      //   if(this.ndcBooking.flight.pricing.total == this.checkedPrice){
      //     price += this.ndcBooking.flight.pricing.total
      //   }
      //   else{
      //     price += this.checkedPrice
      //     this.priceChanged = true
      //   }
      // }
      if (this.ndcBooking.flight.pricing) {
        price += this.ndcBooking.flight.pricing.total;
      }

      return price;
    },
    buildCcEmails() {
      let ccEmails = [];

      if (
        this.traveller.travelPolicy &&
        this.traveller.travelPolicy.ccEmail &&
        this.traveller.travelPolicy.ccEmail != this.traveller.email
      ) {
        ccEmails.push(this.traveller.travelPolicy.ccEmail);
      }

      // Travel arranger selected to be notified
      if (
        this.ccEmailActiveUser &&
        this.activeUser.email != this.traveller.email
      ) {
        if (!ccEmails.includes(this.ccEmailActiveUser)) {
          ccEmails.push(this.activeUser.email);
        }
      }

      // Traveler entered email address
      if (this.ccEmail && this.ccEmail != this.traveller.email) {
        if (!ccEmails.includes(this.ccEmail)) {
          ccEmails.push(this.ccEmail);
        }
      }

      return ccEmails.filter((email) => String(email).search(/@/) > 0);
    },
    buildUdids() {
      let udidAnswers = [];

      this.filteredQuestions.map((udidQuestion) => {
        let udidAnswer = {};
        udidAnswer.number = udidQuestion.udidNumber.toString();
        udidAnswer.value = udidQuestion.answer ?? null;
        udidAnswers.push(udidAnswer);
      });

      return udidAnswers;
    },
    buildPolicy() {
      var business =
        this.$store.getters["travellersAndTrips/getTravellers"].tripType ==
        "business";
      let policy = {
        applied: business ? "Y" : "N",
        notes: this.policyNotes,
      };

      let segmentTravelPolicies = [];
      let rulesTriggered = [];
      let notifications = [];
      let allRules = [];

      if (this.traveller.travelPolicy) {
        allRules = this.traveller.travelPolicy.rules;
      }

      if (business) {
        if (this.ndcBooking.flight.pricing) {
          segmentTravelPolicies.push(this.ndcBooking.flight.travelPolicy);
        }
      }

      // Loop through segments
      for (let segmentTravelPolicy of segmentTravelPolicies) {
        // Check if rules were triggered
        if (
          segmentTravelPolicy === undefined ||
          segmentTravelPolicy.rulesTriggered.length < 1
        ) {
          continue;
        }

        // Loop through triggered rules
        for (let rule of segmentTravelPolicy.rulesTriggered) {
          // Add to list of rules triggered
          rulesTriggered.push(rule);

          // Find the matching rule with full details
          let matchingRule = allRules.find((allRule) => allRule.id == rule.id);

          if (!matchingRule) {
            continue;
          }

          // Build list of actions/notifications
          for (let action of matchingRule.actions) {
            let notification = {
              type: action.type.toLowerCase(),
            };

            if (action.type == "SMS") {
              notification.destination = action.mobilePhone;
            }
            if (action.type == "Email") {
              notification.destination = action.email;
            }
            if (action.type == "Webhook") {
              notification.destination = action.url;
            }

            // Check if the notification method/destination exists
            let notificationExists = notifications.some(
              (el) =>
                el.type == notification.type &&
                el.destination == notification.destination
            );

            // Add to the list if it doesn't exist
            if (!notificationExists) {
              notifications.push(notification);
            }
          }
        }
      }

      // 1 or more rules triggered
      policy.triggered = rulesTriggered.length > 0 ? "Y" : "N";
      policy.rulesTriggered = rulesTriggered;

      // If at least one rule triggered
      if (rulesTriggered.length > 0) {
        // Find hard and soft approval triggered rules
        let hasHardApproval = rulesTriggered.find(
          (rule) => rule.approvalLevel == "hard"
        );
        let hasSoftApproval = rulesTriggered.find(
          (rule) => rule.approvalLevel == "soft"
        );

        if (hasHardApproval) {
          policy.mostStrictApprovalRequired = "hard";
        } else if (hasSoftApproval) {
          policy.mostStrictApprovalRequired = "soft";
        } else {
          policy.mostStrictApprovalRequired = "none";
        }
      }

      // Set the policy notification methods
      policy.notify = notifications;

      return policy;
    },
    buildUnaccompaniedMinor() {
      if (this.isUnaccompaniedMinor && this.unaccompaniedMinor) {
        return this.unaccompaniedMinor;
      }
      return null;
    },
    buildTravelerProfileForRequest(traveler) {
      let data = {};

      data.firstName = traveler.firstName;
      data.lastName = traveler.lastName;
      data.email = traveler.email;
      data.mobilePhone = traveler.mobilePhone;
      data.dateOfBirth = traveler.dateOfBirth;
      data.gender = traveler.gender;

      return data;
    },
    buildBookedBy() {
      var bookedBy = {
        id: this.activeUser.id,
        email: this.activeUser.email,
      };

      return bookedBy;
    },
    buildBookingQueue() {
      let queue = [];

      queue.push(this.buildCheckoutRequest());

      this.guestTravelers.forEach((guest) => {
        queue.push(this.buildGuestCheckout(guest));
      });

      this.$store.commit("pnr/SET_BOOKING_QUEUE", queue);
      //return queue;
    },
    buildCheckoutRequest() {
      // Booking request object
      let payload = {
        meta: {
          stateful: true,
          sessionKey: null,
          step: null,
          preview: this.previewMode,
        },
        bookingKey: this.$helpers.randomString(10),
        trip: {
          recordLocator: this.tripLocator,
        },
        traveler: {
          id: this.traveller.id,
          profile: this.buildTravelerProfileForRequest(this.traveller),
        },
        unaccompaniedMinor: this.buildUnaccompaniedMinor(),
        bookedBy: this.buildBookedBy(),
        airSegment: null,
        carSegment: null,
        hotelSegment: null,
        meetingAttendeeId: null,
        tripName: this.tripName,
        tripDescription: this.tripDescription,
        paymentMethodId: this.selectedPayment.id,
        ccEmails: this.buildCcEmails(),
        udids: this.buildUdids(),
        policy: this.buildPolicy(),
        travelerPrograms: this.travelerPrograms,
      };

      if (this.specialRequest.activated && this.specialRequest.text) {
        payload.messageToAgent = this.specialRequest.text;
      }

      //Build NDC Order Info
      let orderInfo = {};
      orderInfo.offers = [this.selectedOffer];
      orderInfo.passengers = [];

      let passenger = {
        id: 1,
        ptc: "ADT",
        birthdate: this.traveller.dateOfBirth,
        emailAddress: this.traveller.email,
        firstName: this.traveller.firstName,
        lastName: this.traveller.lastName,
        gender: this.traveller.gender,
        salesforceId: this.traveller.id,
        profileId: this.traveller.amadeusRecordLocator,
        travelerPrograms: this.travelerPrograms,
      };

      //Add TSA Precheck Number
      if (this.traveller.tsaPrecheckNumber) {
        passenger.docInfo = {
          id: this.traveller.tsaPrecheckNumber,
          type: 'K',
          issuerCountry: 'US',
          expirationDate: null,
          visaId: this.traveller.tsaPrecheckNumber,
          visaType: "K",
        };
      }

      orderInfo.passengers.push(passenger);

      //Append middle name, if exists, to first name
      if (this.traveller.middleName) {
        passenger.firstName = this.traveller.firstName + " " + this.traveller.middleName
      }

      payload.ndcOrderInfo = orderInfo;

      if (this.ndcBooking.flight.pricing) {
        payload.airSegment = {};
        payload.airSegment.validatingCarrier = this.ndcBooking.flight.airlineCode;
        payload.airSegment.journeys = this.ndcBooking.flight.journeys;
      }

      if (this.pathMixin_isMeeting) {
        payload.meetingAttendeeId = this.$store.state.meetings.meetingInfo.attendeeId;

        // Only set the payment method to the meeting payment method if one isn't already set
        if (!this.selectedPayment) {
          payload.paymentMethodId = this.paymentMethodMeeting;
        }
      }

      return payload;
    },
    buildGuestCheckout(guest) {
      let payload = {
        meta: {
          stateful: true,
          sessionKey: null,
          step: null,
          preview: this.previewMode,
        },
        bookingKey: this.$helpers.randomString(10),
        trip: {
          recordLocator: this.tripLocator,
        },
        traveler: {
          id: guest.profile.id,
          profile: this.buildTravelerProfileForRequest(guest.profile),
        },
        unaccompaniedMinor: this.buildUnaccompaniedMinor(),
        bookedBy: this.buildBookedBy(),
        airSegment: null,
        carSegment: null,
        hotelSegment: null,
        meetingAttendeeId: null,
        meetingAttendeeGuestId: guest.meetingAttendeeGuestId,
        tripName: this.tripName,
        tripDescription: this.tripDescription,
        paymentMethodId: this.selectedPayment.id,
        ccEmails: this.buildCcEmails(),
        udids: this.buildUdids(),
        policy: this.buildPolicy(),
        travelerPrograms: guest.travelerPrograms,
      };

      if (this.specialRequest.activated && this.specialRequest.text) {
        payload.messageToAgent = this.specialRequest.text;
      }

      if (guest.solution.flight.pricing) {
        payload.airSegment = {};
        payload.airSegment.validatingCarrier =
          guest.solution.flight.airlineCode;
        payload.airSegment.journeys = guest.solution.flight.journeys;
      }

      if (this.pathMixin_isMeeting) {
        // Only set the payment method to the meeting payment method if one isn't already set
        if (!this.selectedPayment) {
          payload.paymentMethodId = this.paymentMethodMeeting;
        }
      }

      return payload;
    },
    submitCheckout() {
      //build the pnr queue
      if (this.booking_queue.length <= 0) {
        this.buildBookingQueue();
      }

      //save the meeting attendee registration time
      if (this.pathMixin_isMeeting) {
        this.saveRegistrationTime();
      }

      this.$app
        .huddleLabsServerCall("amadeus/pnr/multi-checkout", {
          pnrs: this.booking_queue,
        })
        .then((response) => {
          this.$store.commit("pnr/SET_PNR_PENDING", this.booking_queue[0]);
          this.checkout_pending = true;
        });
    },
    pnrComplete(result) {
      //1. remove completed pnr from booking queue
      this.$store.commit("pnr/DEL_PNR_FROM_QUEUE", result.bookingKey);
      this.$store.commit("pnr/SAVE_BOOKING_STATUS", result);

      //if a pnr fails, clear the booking queue to cancel the remaining pnrs
      if (result.status == "failed") {
        this.$store.commit("pnr/SET_BOOKING_QUEUE", []);
        //Clear state.result and guest with the pending data?
      }

      if (this.booking_queue.length > 0) {
        //2. get next pnr object from queue
        let next = this.booking_queue[0];
        //3. set next pnr as active
        this.$store.commit("pnr/SET_PNR_PENDING", next);
      } else {
        this.checkoutComplete();
      }
    },
    checkoutComplete() {
      // clear booking state
      this.$store.dispatch("bookTravel/clearBooking", {});
      this.$store.commit("pnr/SET_PNR_PENDING", {});
      this.checkout_pending = false;

      //send to confirmation page
      if (this.isMeetingMode) {
        this.$router.push({ path: "/meetings/confirmation" });
      } else {
        this.$router.push({ path: "/pnr" });
      }
    },
    checkScreenSize() {
      if (window.innerWidth <= 769) {
        //console.log("window.innerWidth: ", window.innerWidth);
        this.isDesktop = false;
      }
    },
    getTravelPolicy() {
      if (!this.traveller.travelPolicyId) return;

      var body = {
        travelPolicyId: this.traveller.travelPolicyId,
      };
      this.$app
        .huddleLabsServerCall("profile/travel-policy", body)
        .then((result) => {
          this.travelPolicy = result.data;
        });
    },
  },
  mounted() {
    this.checkScreenSize();
    //this.loadProfile();
    this.getUdids();
    this.getTravelPolicy();

    this.travelerPrograms = this.findRelevantPrograms(
      this.traveller.travelerPrograms
    );

    this.guestTravelers.forEach((guest) => {
      this.$set(
        guest,
        "travelerPrograms",
        this.findRelevantPrograms(guest.travelerPrograms)
      );
    });

    //clear any previously saved pending checkout state
    this.$store.dispatch("bookTravel/setBooked", false);
    this.$store.commit("pnr/SET_PNR_PENDING", {});
    this.$store.commit("pnr/CLEAR_BOOKING_STATUS");

    this.$nextTick(() => {
      let expireTime = moment.utc(this.selectedOffer.expireTime);
      this.countdown =
        expireTime > moment.utc()
          ? Math.abs(moment().diff(expireTime, "seconds"))
          : 0;
      this.countdownTimer();
    });
  },
};
</script>

<style scoped>
.bookingButtonContainer {
  position: relative;
  bottom: -25px;
}
.bookingButtons {
  position: relative;
}
.buttonContainer {
  position: absolute;
  z-index: 20;
}

@media screen and (max-width: 601px) {
  .bookingButtonContainer {
    bottom: -10px;
  }
  .buttonContainer {
    left: 41%;
    width: 61%;
    top: 30px;
  }
  .bookingButtons {
    left: -41%;
  }
}

@media screen and (min-width: 602px) and (max-width: 768px) {
  .buttonContainer {
    left: 41%;
    width: 61%;
    top: 50px;
  }
  .bookingButtons {
    left: -41%;
  }
}

@media screen and (min-width: 769px) and (max-width: 1215px) {
  .buttonContainer {
    left: 42%;
    width: 61%;
    top: 30px;
  }
  .bookingButtons {
    left: -42%;
  }
}

@media screen and (min-width: 1216px) {
  .buttonContainer {
    left: 41%;
    width: 61%;
    top: 70px;
  }
  .bookingButtons {
    left: -41%;
  }
}
</style>
